import { render, staticRenderFns } from "./person_flag.vue?vue&type=template&id=5fa09ce4&scoped=true"
import script from "./person_flag.vue?vue&type=script&lang=js"
export * from "./person_flag.vue?vue&type=script&lang=js"
import style0 from "./person_flag.vue?vue&type=style&index=0&id=5fa09ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa09ce4",
  null
  
)

export default component.exports